import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CalendarPage from '../CalendarItem/DashboardCalendar';
import DonutChart from './DonutChart';
import BarChart from './Barchart';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import ModalType from '../../../pages/Badge/modalBadges';
import ClassCarosel from './ClassCarosel';
import ClassStatistics from './ClassStatistics';
import LiveClasses from '../LiveClasses/liveClasses';
import { useSelector } from 'react-redux';
import { ArrowUp, ArrowDown } from 'react-feather';
import styles from 'styles/Course.module.scss';
import classnames from 'classnames';
import { getSelectedCentre } from 'store/master';
import { useUser } from '../../../hooks';
import reportApi from '../../../api/reportApi';
import { formatTimeHandlerHrs, handleToastError } from 'helpers';

const LearnerItem = () => {
  const [totalClass, setTotalClass] = useState(0);
  const [addTypeModal, setAddTypeModal] = useState(false);
  const auth = useUser();
  const selectedCentre = useSelector(getSelectedCentre);
  const [percentage, setPercentage] = useState(0);
  const [barminute, setBarMinutes] = useState(0);
  const [intakecount, setIntakeCount] = useState({});
  const [newcourse, setNewCourse] = useState(0);

  let totalintake =
    (intakecount?.coursesInProgress || 0) +
    (intakecount?.coursesNotStarted || 0) +
    (intakecount?.completedCourses || 0);

  async function barChartdetails() {
    try {
      const response = await reportApi.getBarChartValue(
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setBarMinutes(response.totalMinutes);
      setPercentage(response.totalPercent);
    } catch (error) {
      handleToastError(error);
    }
  }

  async function StatisticsCount() {
    try {
      const response = await reportApi.getDonutChartValue(
        auth?._id,
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setIntakeCount(response);
      setNewCourse(response?.coursesNotStarted);
    } catch (error) {
      handleToastError(error);
    }
  }

  useEffect(() => {
    barChartdetails();
    StatisticsCount();
  }, [selectedCentre]);

  return (
    <>
      <div className="container learner-cardbody" style={{ marginTop: -20 }}>
        <section>
          <div className="row">
            <div className="col-md-4">
              <ClassStatistics setTotalClass={setTotalClass} />
            </div>
            <div className="col-md-3">
              <ClassCarosel />
            </div>
            <div className="col-md-5">
              <h6 className="heading_text_title">My Calendar</h6>

              <CalendarPage dayOrMonth="dayGridMonth" learner="learner" />
            </div>
          </div>
        </section>
        <section style={{ marginTop: 25 }}>
          <div className="row">
            <div className="col-md-4">
              <div className="col-md-12 m-0 p-0">
                <div className="bar-chart-carddesign">
                  <div className="card-body">
                    <h5 className="sub-heading_text_title">Total Hours</h5>
                    <p
                      className={classnames(
                        'dashboard-counts',
                        styles['dashboard-counts'],
                      )}
                    >
                      {formatTimeHandlerHrs(barminute)}
                      <span style={{ fontSize: '20px' }}> Hrs</span>
                      {Math.round(percentage) <= 0 ? (
                        <ArrowDown style={{ color: 'green' }} />
                      ) : (
                        <ArrowUp style={{ color: 'green' }} />
                      )}
                      <span
                        style={{
                          color: 'rgb(76,218,92)',
                          fontSize: '20px',
                        }}
                      >
                        {Math.round(percentage)}%
                      </span>
                    </p>
                    <BarChart />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="col-lg-12 m-0 p-0">
                <div className="bar-chart-carddesign">
                  <div className="card-body">
                    <h5 className="sub-heading_text_title">Total Classes</h5>
                    <p
                      className={classnames(
                        'dashboard-counts',
                        styles['dashboard-counts'],
                      )}
                    >
                      {totalintake}
                      {totalintake <= 0 ? (
                        <ArrowDown style={{ color: 'green' }} />
                      ) : (
                        <ArrowUp style={{ color: 'green' }} />
                      )}
                      <span
                        style={{
                          color: 'rgb(76,218,92)',
                          fontSize: '20px',
                        }}
                      >
                        {newcourse} NEW
                      </span>
                    </p>
                    <div className="row">
                      <DonutChart totalClass={totalClass} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 learner_live_classes">
              <div className="live_classes">
                <LiveClasses />
              </div>
            </div>
          </div>
        </section>

        <ModalType open={addTypeModal} toggle={() => setAddTypeModal(false)} />
      </div>
    </>
  );
};

LearnerItem.propTypes = {
  course: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default LearnerItem;
